import React from 'react';
import { motion } from 'framer-motion';
import skills from '../../data/skills';

const Skills = () => {
  return (
    <section id="skills" className="section-padding bg-[#f7f8fb]">
      <div className="container-wrapper">
        <motion.div
          className="mb-14"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, ease: [0.19, 1, 0.22, 1] }}
        >
          <p className="section-label mb-3">Toolkit</p>
          <h2 className="mb-4 text-3xl font-black tracking-normal text-[#191922] sm:text-4xl md:text-5xl">
            Tools selected for delivery
          </h2>
          <p className="max-w-2xl text-base leading-relaxed text-slate-600">
            I choose the stack based on the workflow: React when the interface needs custom polish,
            Xano and WeWeb when speed matters, and AI/automation where it removes real operator work.
          </p>
        </motion.div>

        <motion.div
          className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3"
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          variants={{
            hidden: { opacity: 0 },
            show: { opacity: 1, transition: { staggerChildren: 0.07 } },
          }}
        >
          {skills.map((group) => (
            <motion.article
              key={group.category}
              className="rounded-lg border border-slate-200 bg-white p-6 shadow-sm"
              variants={{
                hidden: { opacity: 0, y: 16 },
                show: { opacity: 1, y: 0, transition: { duration: 0.5, ease: [0.19, 1, 0.22, 1] } },
              }}
            >
              <h3 className="mb-4 text-[12px] font-bold uppercase tracking-[0.12em] text-sky-600">
                {group.category}
              </h3>
              <div className="flex flex-wrap gap-2">
                {group.items.map((item) => (
                  <span
                    key={item}
                    className="rounded-md border border-slate-200 bg-slate-50 px-3 py-1.5 text-sm font-medium text-slate-700"
                  >
                    {item}
                  </span>
                ))}
              </div>
            </motion.article>
          ))}
        </motion.div>
      </div>
    </section>
  );
};

export default Skills;
